import { BaseService } from "./BaseService";

const AppConfigService = {
    async obtenerMensajeFlotante() {
        const respuesta = await BaseService.get("/app-config/mensaje-flotante");
        return respuesta.data;
    },
    async ordenarLegajoAlfabeticamente() {
        const respuesta = await BaseService.get("/app-config/ordenar-legajo-alfabeticamente");
        return respuesta.data;
    },
};

export default AppConfigService;
